import "./MyAccount.css";
import { useState } from "react";
import Button from "../../Model/Button";
import ModifyPassword from "../ModifyPassword/ModifyPassword";
import Loc from "../../../Loc/Loc";

interface MyAccountProps {
    setPageOnClick: (page: string) => void;
}

export default function MyAccount (props: MyAccountProps) {
    const [isLoading, setIsLoading] = useState(false);
    const buttonChangePW: Button = {className : "btn btn-primary", type : "submit", title : Loc.trad().MyAccountChange, onClick : () => {}, isLoading : isLoading};

    const buttons = [buttonChangePW];

    return (
        <ModifyPassword firstConnection={false} buttons={buttons} setIsLoading={setIsLoading} setPageOnClick={props.setPageOnClick}></ModifyPassword>
    )
}